import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';

export const useCache = (data: any) => {
  const [cache, setCache] = useState(data);
  useEffect(() => {
    if (!isEqual(cache, data)) {
      setCache(data);
    }
  }, [cache, data]);
  return cache;
};
